<template>
    <div key="patreon" class="flex flex-col self-center">
        <the-main-header name="Patreon" illuName="patreon" />
        <section
            class="flex flex-col p-5 sm:p-7 md:p-10 xl:p-12 bg-section-bg-500 dark:bg-section-bg-dark-500 sm:rounded-2xl shadow-big-light"
        >
            <article
                class="prose text-app-font-500 dark:text-app-font-dark-500"
            >
                <h3 class="text-app-font-500 dark:text-app-font-dark-500">
                    Hey {{ name }},
                </h3>
                <p v-if="isPatron">
                    We would like to thank you for your support through
                    <a
                        class="text-app-font-500 dark:text-app-font-dark-500"
                        href="https://www.patreon.com/FaizanDurrani/posts"
                    >
                        Patreon
                    </a>
                    these past few months.
                </p>
                <p v-else>
                    Even if you are not subscribed to our
                    <a
                        class="text-app-font-500 dark:text-app-font-dark-500"
                        href="https://www.patreon.com/FaizanDurrani/posts"
                    >
                        Patreon
                    </a>
                    anymore, we would like to thank you for the support you gave
                    us these past months.
                </p>
                <p>
                    You contributed to a total amount of ${{ totalPledged }} to
                    the project, it really means a lot to us!
                </p>

                <p>
                    We are working hard to bring you the best experience to read
                    your favorite mangas on iOS, iPadOS, and soon, desktop.
                </p>
                <p>
                    We hope that you are enjoying the reading experience as much
                    as we are enjoying developing it for you.
                </p>
                <p>Thank you!</p>
                <p class="text-right">The Paperback Team</p>
            </article>
        </section>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useQuery, useResult } from '@vue/apollo-composable'
import TheMainHeader from '@/common/components/TheMainHeader.vue'
import { GET_USER_QUERY } from '@/services/apollo/requests'
import { GraphQLUserData } from '@/services/apollo/types'

export default defineComponent({
    name: 'Patreon',
    components: {
        TheMainHeader,
    },
    setup() {
        const { result, loading } = useQuery(GET_USER_QUERY)

        const isPatron = useResult(
            result,
            false,
            (data: GraphQLUserData) => data.getUserData?.patreonStatus?.isPatron
        )

        const name = useResult(
            result,
            '',
            (data: GraphQLUserData) =>
                data.getUserData?.patreonStatus?.patreonName
        )

        const totalPledged = useResult(
            result,
            '',
            (data: GraphQLUserData) =>
                Number(data.getUserData?.patreonStatus?.lifetimePledgeCents) /
                100
        )

        return {
            loading,
            isPatron,
            name,
            totalPledged,
        }
    },
})
</script>
